import { __spreadArrays } from "tslib";
import insertScript from './insertScript';
import insertStyle from './insertStyle';
export var merge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Object.assign.apply(Object, __spreadArrays([{}], args));
};
/**
 * 加载图标
 * @see https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.11&manage_type=myprojects&projectId=633382
 */
// @TODO
// 需要归类和精简
insertScript('//at.alicdn.com/t/font_633382_myktiheng8e.js');
insertScript('//at.alicdn.com/t/font_605773_6pz0ae4h65n.js');
insertScript('//at.alicdn.com/t/font_550145_mzvjphrdj5s.js');
// studio 公开icon
insertScript('//at.alicdn.com/t/font_2058435_dcnu9dszc5e.js');
// 加载动画
var loadingCircle = "\n@keyframes loadingCircle {\n  0% {\n    transform-origin: 50% 50%;\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform-origin: 50% 50%;\n    transform: rotate(360deg);\n  }\n}\n";
insertStyle(loadingCircle);
export var styles = {
    icon: {
        width: '1em',
        height: '1em',
        // 不知道为什么是 -0.15em，估计是和字体的设计有关，但是不要删。
        // https://www.iconfont.cn/help/detail?spm=a313x.7781069.1998910419.d8cf4382a&helptype=code
        'vertical-align': '-0.15em',
        fill: 'currentColor',
        overflow: 'hidden',
    },
    size: {
        default: {
        // 和父层字体保持一致
        },
        xxs: {
            fontSize: '8px',
        },
        xs: {
            fontSize: '12px',
        },
        small: {
            fontSize: '16px',
        },
        medium: {
            fontSize: '20px',
        },
        large: {
            fontSize: '24px',
        },
        xl: {
            fontSize: '32px',
        },
        xxl: {
            fontSize: '48px',
        },
        xxxl: {
            fontSize: '64px',
        },
    },
    type: {
        loading: {
            animation: 'loadingCircle 2s infinite linear',
        },
    },
};
